import { render, staticRenderFns } from "./CheckinApproveMail.vue?vue&type=template&id=13ceae28"
import script from "./CheckinApproveMail.vue?vue&type=script&lang=js"
export * from "./CheckinApproveMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports